import { render, staticRenderFns } from "./DouleurOrteilsMarteaux.vue?vue&type=template&id=be3f89b8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports